import m from 'mithril';
import vwAdyenConfirmation from '../components/vwAdyenConfirmation';
import vwEcomConfirmation from '../components/vwEcomConfirmation';
import Loading from './components/loading';
import paymentSession from '../lib/paymentSession';
import constants from '../lib/constants';

const vwConfirmation = {
	loading: true,
	sessionCompleted: false,
	view: ({ attrs: { sessionId, returnUrl = false, redirectResult = false } }) => {
		let component;

		paymentSession.initSession({
			sessionId: sessionId,
		});

		if (vwConfirmation.sessionCompleted === false && redirectResult) {
			component = m(vwAdyenConfirmation, {
				redirectResult: redirectResult,
				sessionComplete: () => {
					if (returnUrl) {
						window.location.href = returnUrl;
						return;
					}

					vwConfirmation.sessionCompleted = true;
					vwConfirmation.loading = false;
					paymentSession.showConfirmation();
				},
				sessionPending: () => {
					vwConfirmation.loading = false;
					m.redraw();
				},
			});
		} else if (returnUrl) {
			window.location.href = returnUrl;
		} else {
			component = m(vwEcomConfirmation, {
				sessionComplete: () => {
					vwConfirmation.loading = false;
					m.redraw();
				},
			});
		}

		return [
			vwConfirmation.loading === true
				? m(
						'div',
						{
							class: `container container--loading`,
						},
						[
							m('img', { src: constants.IMAGE_ECOM_PAY, class: 'loading__logo', alt: 'elockers' }),
							Loading,
						]
				  )
				: '',

			m('div', { class: 'container', style: `display: ${vwConfirmation.loading === true ? 'none' : 'flex'}` }, [
				m('div', { class: 'card' }, [
					m('div', { class: 'card__upper' }, component),
					m('div', { class: 'card__lower' }, [
						m('div', { class: 'card__lower__content' }, [
							m('div', { class: 'payment-by' }, [m('span', 'Payment by'), m('img', { src: constants.IMAGE_ECOM_PAY, alt: 'Ecom Pay Logo' })]),
						]),
					]),
				]),
			]),
		];
	},
};

export default vwConfirmation;
